import { z } from "zod";

const VALIDATION_MESSAGE = {
	chargePrice: "請求するキャンセル料金は1円以上で入力してください",
};

export const ReservationDetailChargeCancelFeeInputZodSchema = z.object({
	chargePrice: z
		.number()
		.min(1, { message: VALIDATION_MESSAGE.chargePrice })
		.optional() // undefined 時に、カスタムエラーとしたいので optional にしている
		.transform((value, ctx) => {
			if (value === undefined) return ctx.addIssue({ code: "custom", message: VALIDATION_MESSAGE.chargePrice });
			return value;
		}),
});

export type ReservationDetailChargeCancelFeeInputType = z.infer<typeof ReservationDetailChargeCancelFeeInputZodSchema>;
